export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.rejection_reasons) {
        return {...state, ...payload.rejection_reasons};
      }
      return state;
    }
  }
};
